export const BottomCallToAction = (props) => {
    const promo = props.promo;
    const onClick = props.onClick;
    return (<div id="get-started" className="atf-section-padding atf-footer-offset">
              <div className="atf-brand-overlay">
                  <div className="container">
                      <div className="row justify-content-center clearfix wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s" data-wow-offset="0">
                          {promo ? <div className="col-lg-8 col-md-8 col-11 text-center  atf-mailchamp-subscribe">
                              <h2 className="mb-1 text-center heading-size" style={{color: "white"}}>Don't like specials?</h2>
                              <div>That's ok. Install normally here.</div>
                              <div>
                                  <a href="#none" onClick={onClick} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                  </div>
                          </div> : <div className="col-lg-8 col-md-8 col-11 text-center  atf-mailchamp-subscribe">
                              <h2 className="mb-1 text-center heading-size" style={{color: "white"}}>Try it today</h2>
                              <div className="mb-1 text-center" style={{color:'white'}}>Free for 7 days. Cancel any time.</div>
                              <div>
                                  <a href="#none" onClick={onClick} ><img src="Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store" style={{ height: '65px', padding: '11px 10px 11px 10px' }} /></a>
                                  </div>
                          </div> }
                      </div>
                  </div>
              </div>
          </div>
    
    );
}

export default BottomCallToAction;